export const cabecalho_histograma = {
  text: "Histograma",
  value: "descricao_linha",
  style: {
    backgroundColor: '#f7f8ff',
    position: 'sticky !important',
    zIndex: '1 !important',
    minWidth: '400px',
    left: 0,
    right: 'auto',
    border: 0,
    borderRight: '1px dashed rgba(0,0,0,.3)',
  }
};

export const map_data_para_cabecalho_grid = (data, index) => ({
  text: data,
  value: data,
  style: {
    borderLeft: index > 0 ? '1px dashed rgba(0,0,0,.3)' : 0,
    textAlign: 'center',
    borderBottomStyle: 'dashed',
  },
  styleHeader: {
    minWidth: '90px !important',
    width: '90px !important',
    backgroundColor: '#f7f8ff',
    borderLeft: index > 0 ? '1px dashed rgba(0,0,0,.3)' : 0,
    textAlign: 'center',
    borderBottomStyle: 'dashed',
  }
});
